<template>
    <div class="setting-content--section">
        <b-form @submit="onSubmit">
            <b-form-group id="input-group-1" label-cols-sm="0" label-align-sm="right" label-class="gk-label-margin">
                <b-form-checkbox id="input-1" class="checkbox-bg-color" v-model="form.profile.send_emails" @change="onFormChange" switch><span v-translate>Keep me informed on Gekko updates via emails</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-2" label-cols-sm="0" label-align-sm="right" label-class="gk-label-margin">
                <b-form-checkbox id="input-2" class="checkbox-bg-color" v-model="form.profile.send_push_notifications" @change="onFormChange" switch><span v-translate>Send push notifications on my mobile with reminders for deadlines</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-3" label-cols-sm="0" label-align-sm="right" label-class="gk-label-margin">
                <b-form-checkbox id="input-3" class="checkbox-bg-color" :disabled="!user.is_premium" v-model="form.profile.send_in_app_mobile" @change="onFormChange" switch><span v-translate>Send in app notifications to my mobile (with reminders, updates, new developments, special offers, etc.)</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-4" label-cols-sm="0" label-align-sm="right" label-class="gk-label-margin">
                <b-form-checkbox id="input-4" class="checkbox-bg-color" :disabled="!user.is_premium" v-model="form.profile.send_in_app_web" @change="onFormChange" switch><span v-translate>Send notifications to my online account (with reminders, updates, new developments, special offers, etc.)</span></b-form-checkbox>
            </b-form-group>
            <b-alert class="float-alert-top" :show="showDismissibleCountdown" variant="success" dismissible @dismissed="showDismissibleCountdown=0" v-translate>
              Settings successfully updated!
            </b-alert>
            <b-form-group id="input-group-5" label-cols-sm="0" label-align-sm="right" label-class="gk-label-margin" label="">
                <GekkoButton 
                    :text="$gettext('Save Settings')" 
                    icon="fa-solid fa-floppy-disk"
                    type="submit"
                />
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import UserService from "@/store/services/user.service.js";
import ProfileService from "@/store/services/profile.service.js";
import GekkoButton from "@/components/GekkoButton";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "Notifications",
    components: { GekkoButton },
    mixins: [settingsPageSetup],
    data() {
        return {
        allSelected: null,
            pageSettings: {
                title: this.$gettext("Gekko messages and notifications"),
                showCompanyPicker: false
            },
            formChanged: false,
            form: {
                profile: {}
            },
            user: {},
            showDismissibleCountdown: 0,
        }
    },
    created(){
        var vm = this;
        UserService.retrieveCurrent({extended: 'True'}).then(function(response){
            vm.user = response.data;
        });
        ProfileService.list({user: window.user_id}).then(function (response) {
            vm.form.profile = response.data[0];
        })
    },
    methods: {
        onSubmit(evt) {
            var vm = this;
            evt.preventDefault();
            delete this.form.profile.avatar;
            delete this.form.profile.avatar_thumb;
            ProfileService.update(this.form.profile.id, this.form.profile).then(function(){
                vm.showDismissibleCountdown = 2;
                vm.formChanged = false;
            })
        },
        onFormChange(){
            this.formChanged = true;
        }
    },
    beforeRouteLeave (to, from , next) {
      var answer = true;
      if(this.formChanged){
        answer = window.confirm(this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'))
      }
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
};
</script>
<style >
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #0575ff;
    background-color: #0575ff;
}
.gk-label-margin{
    padding-right: 15px !important;
}
.float-alert-top{
    position: fixed !important;
    top: 50px;
    right: 15%;
    z-index: 1000;
}
</style>
